export default {
  state: {
    map: {},
    mapContents: [],
    mapNodes: [],
    mapNodesEnrollment: [],
    mapNodesEnrollmentNavigation: [],
    selectedMap: {},
    selectedMapNode: {},
    selectedMapNodeTask: {},
    studentMapEnrollments: []
  },

  getters: {
    getMap (state) {
      return state.map
    },

    getMapContents (state) {
      return state.mapContents
    },

    getMapNodes (state) {
      return state.mapNodes
    },

    getMapNodesEnrollment (state) {
      return state.mapNodesEnrollment
    },

    getMapNodesEnrollmentNavigation (state) {
      return state.mapNodesEnrollmentNavigation
    },

    getSelectedMap (state) {
      return state.selectedMap
    },

    getSelectedMapNode (state) {
      return state.selectedMapNode
    },

    getSelectedMapNodeTask (state) {
      return state.selectedMapNodeTask
    },

    getStudentMapEnrollments (state) {
      return state.studentMapEnrollments
    }
  },

  mutations: {
    setMap (state, map) {
      state.map = map
    },

    setMapContents (state, mapContents) {
      state.mapContents = mapContents
    },

    setMapNodes (state, mapNodes) {
      state.mapNodes = mapNodes
    },

    setMapNodesEnrollment (state, mapNodesEnrollment) {
      state.mapNodesEnrollment = mapNodesEnrollment
    },

    setMapNodesEnrollmentNavigation (state, mapNodesEnrollmentNavigation) {
      state.mapNodesEnrollmentNavigation = mapNodesEnrollmentNavigation
    },

    setSelectedMap (state, selectedMap) {
      state.selectedMap = selectedMap
    },

    setSelectedMapNode (state, selectedMapNode) {
      state.selectedMapNode = selectedMapNode
    },

    setSelectedMapNodeTask (state, selectedMapNodeTask) {
      state.selectedMapNodeTask = selectedMapNodeTask
    },

    setStudentMapEnrollments (state, studentMapEnrollments) {
      state.studentMapEnrollments = studentMapEnrollments
    },

    unsetMap (state) {
      state.map = {}
    },

    unsetMapContents (state) {
      state.mapContents = []
    },

    unsetMapNodes (state) {
      state.mapNodes = []
    },

    unsetMapNodesEnrollment (state) {
      state.mapNodesEnrollment = []
    },

    unsetMapNodesEnrollmentNavigation (state) {
      state.mapNodesEnrollmentNavigation = []
    },

    unsetSelectedMapNode (state) {
      state.selectedMapNode = {}
    },

    unsetSelectedMap (state) {
      state.selectedMap = {}
    },

    unsetSelectedMapNodeTask (state) {
      state.selectedMapNodeTask = {}
    },

    unsetStudentMapEnrollments (state) {
      state.studentMapEnrollments = []
    }
  }
}
